module.exports = __webpack_public_path__ + "static/fonts/manrope-bold.9b61c79f.woff2";